import { Stack } from 'expo-router';
import React from 'react';

function DiscoverMoreLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default DiscoverMoreLayout;
